// Vyby Live store root. Socket `live:event`s (bound in store/index.js) are
// routed here by `type` to the sub-modules.
import discovery from '@/store/live/discovery'
import meters from '@/store/live/meters'
import stream from '@/store/live/stream'
import timeline from '@/store/live/timeline'
import clips from '@/store/live/clips'

export default {
  namespaced: true,
  modules: {
    discovery,
    meters,
    stream,
    timeline,
    clips,
  },
  actions: {
    onEvent: (store, { data }) => {
      const event = data || {}
      switch (event.type) {
        case 'stream.started':
        case 'stream.updated':
        case 'stream.ended':
          store.commit('discovery/upsertStream', event.stream)
          store.dispatch('meters/fromStream', event.stream)
          break
        case 'stream.meters.updated':
          store.dispatch('meters/update', event)
          break
        case 'rankings.updated':
          store.commit('discovery/rankings', event.rankings)
          break
        case 'moment.created':
        case 'moment.updated':
        case 'sentence.scored':
        case 'chunk.deleted':
          store.dispatch('stream/onEvent', event)
          break
        default:
          break
      }
    },
  },
}
